import { Txt } from '@vst/beam';
import { Trans, useTranslation } from 'react-i18next';

import styles from '../TermsAndConditionsModal/styles.module.scss';

const FiberContent = () => {
  const { t } = useTranslation('ChangePlan', {
    keyPrefix: 'orderReview.details.terms.modal.content.fiber',
  });

  const speedList = t('speedList', { returnObjects: true }) as string[];
  const tightBreak = <span aria-hidden="true" className={styles['tightBreak']} />;

  return (
    <>
      <Txt variant="tinyBold" component="p">
        {t('heading')}
      </Txt>

      <Txt variant="tinyRegular" component="p">
        <Trans
          ns="ChangePlan"
          i18nKey="orderReview.details.terms.modal.content.fiber.body"
          components={{ bold: <strong />, br: tightBreak }}
        />
      </Txt>

      <Txt variant="tinyRegular">{t('speedHeading')}</Txt>
      <ul>
        {speedList.map((item, index) => (
          <li key={index}>
            <Txt variant="tinyRegular">{item}</Txt>
          </li>
        ))}
      </ul>

      <Txt variant="tinyRegular">
        <Trans
          ns="ChangePlan"
          i18nKey="orderReview.details.terms.modal.content.fiber.fiberCityAid"
          components={{ br: tightBreak }}
        />
      </Txt>
    </>
  );
};

export default FiberContent;
